import { useAxiosQuery } from 'hooks/useAxiosQuery';
import { ASSET_CACHE_KEY  } from 'services/queryKeys';
import { GreenerUnit } from 'types';

export const useGetAsset = (assetExternalId: string) => {
  const { data = {} as GreenerUnit, ...rest } = useAxiosQuery<GreenerUnit>(
    ASSET_CACHE_KEY(assetExternalId),
    `/greener-units/${assetExternalId}/`,
    { enabled: !!assetExternalId }
  );

  return { asset: data, ...rest };
};
